import { render, staticRenderFns } from "./Aka.vue?vue&type=template&id=202635fd"
import script from "./Aka.vue?vue&type=script&lang=js"
export * from "./Aka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports